import React from 'react';
import { capitalize } from 'Helpers/utils';
import { Img, ImgProps, Icon } from 'pounceV2';
import { useTheme } from '@mui/material';

export interface AvailableLogProviderLogoV3Props extends Omit<
  React.ComponentProps<'img'>,
  keyof ImgProps | 'ref'
> {
  id: string;
  // if provided, simply use this value as the src of the Img
  useSrc?: string;
  size?: number;
  mr?: number;
  alt?: string;
  nativeHeight?: number;
}

const AvailableLogProviderLogoV3: React.FC<AvailableLogProviderLogoV3Props> = ({
  id,
  useSrc,
  alt,
  nativeHeight = undefined,
  mr = undefined,
  size = 20,
  ...rest
}) => {
  const theme = useTheme();
  const altText = alt ?? `${capitalize(id)} logo`;
  let imgSrc = useSrc;
  if (!useSrc) {
    try {
      if (theme.palette.mode === 'light') {
        // If user is in light mode, let's try to get a light mode version of the logo
        // and if one doesn't exist, we default to the previously existing logo. This
        // doesn't cover the case where we _need_ a light mode logo, but it
        // won't cause any issues due to the fallback
        try {
          // eslint-disable-next-line
          imgSrc = require(`Assets/logProviders/${id}-light.svg`);
        } catch (e) {
          // eslint-disable-next-line
          imgSrc = require(`Assets/logProviders/${id}.svg`);
        }
      } else {
        // eslint-disable-next-line
        imgSrc = require(`Assets/logProviders/${id}.svg`);
      }
    } catch (e) {
      return (
        <Icon
          type="integrations"
          width={size}
          height={size}
          color={theme.palette.componentTokens.buttons.colors.coreIcon.ghost.assets.resting}
        />
      );
    }
  }

  return (
    <Img
      alt={altText}
      nativeWidth={size}
      nativeHeight={nativeHeight}
      mr={mr}
      objectFit="contain"
      src={imgSrc}
      {...rest}
    />
  );
};

export default AvailableLogProviderLogoV3;
